import styled from 'styled-components/macro'
import InputLabel from '@material-ui/core/InputLabel'
import Grid from 'components/Grid'

export const Wrapper = styled.div`
  display: grid;
  row-gap: 40px;
  width: 928px;
  height: 100%;
  padding: 48px;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
`

export const GridBotoes = styled(Grid)`
  align-items: end;
  justify-content: end;
  justify-items: end;
`
